import React, { useEffect } from 'react'

import { usePersonalDetailsGoBack } from '@pages/Signup/routes/usePersonalDetailsGoBack'

import { useSignup } from '@context/SignupContext'

import { getLeadFromStorage } from '@hooks/useStorage'

import { SignupWarningMessages } from '../../../Components/SignupWarningMessages'
import { PersonalDetailsTemplate } from '../PersonalDetailsTemplate'
import { PersonalDetailsStep5Form } from './PersonalDetailsStep5Form'

export interface PersonalDetailsStep5FormValues {
  firstName: string
  password: string
  confirmPassword: string
}

interface PersonalDetailsStep5PageProps {
  onSubmit(values: PersonalDetailsStep5FormValues): void
}

export const PersonalDetailsStep5Page: React.FC<PersonalDetailsStep5PageProps> = (props) => {
  const { onSubmit } = props
  const { setLead, signupData } = useSignup()
  const goBack = usePersonalDetailsGoBack()

  useEffect(() => {
    if (!signupData.lead) {
      const lead = getLeadFromStorage()
      if (lead) {
        setLead(lead)
      }
    }
  }, [setLead, signupData.lead])

  if (!signupData.lead) {
    return null
  }

  return (
    <PersonalDetailsTemplate
      lead={signupData.lead}
      step={5}
      isLoading={false}
      goBack={goBack}
      reversed
    >
      <SignupWarningMessages />

      <PersonalDetailsStep5Form
        initialValues={
          {
            ...signupData.values,
            firstName: signupData.lead?.firstName,
          } as PersonalDetailsStep5FormValues
        }
        leadData={{
          id: signupData.lead?.id,
          token: signupData.lead?.token,
        }}
        onSubmit={onSubmit}
      />
    </PersonalDetailsTemplate>
  )
}
